import { render, staticRenderFns } from "./unitofthedayhelp.vue?vue&type=template&id=70fdad1d&"
import script from "./unitofthedayhelp.vue?vue&type=script&lang=js&"
export * from "./unitofthedayhelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70fdad1d')) {
      api.createRecord('70fdad1d', component.options)
    } else {
      api.reload('70fdad1d', component.options)
    }
    module.hot.accept("./unitofthedayhelp.vue?vue&type=template&id=70fdad1d&", function () {
      api.rerender('70fdad1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KhEVVxmY0Fxc/JS/comp/unitofthedayhelp.vue"
export default component.exports